export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      aircraft: 'Aéronefs',
      projects: 'Réalisations',
      about: 'À Propos',
      faq: 'FAQ',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'PRESTACO',
        subtitle: 'Votre Partenaire de Confiance',
        description: 'Solutions complètes pour entreprises et capacités aériennes stratégiques au Sénégal',
        cta: 'Découvrir nos services',
        ctaSecondary: 'Nous contacter'
      },
      intro: {
        title: 'Leader en Solutions d\'Entreprise',
        description: 'Depuis 2023, PRESTACO est une entreprise sénégalaise spécialisée dans la fourniture de solutions complètes pour entreprises, allant de l\'équipement professionnel aux capacités aériennes stratégiques.'
      },
      stats: {
        founded: { value: '2023', label: 'Année de création' },
        revenue: { value: '200M+', label: 'FCFA de revenus' },
        services: { value: '10+', label: 'Catégories de services' },
        clients: { value: '100%', label: 'Satisfaction client' }
      }
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Une gamme complète de solutions professionnelles',
      categories: [
        {
          title: 'Équipements Professionnels',
          description: 'Tenues de travail spécialisées, accessoires personnalisés, équipements de sécurité pour tous secteurs',
          items: ['Tenues de travail', 'Équipements de sécurité', 'Accessoires personnalisés'],
          image: 'https://images.unsplash.com/photo-1662309376159-b95fb193d96b'
        },
        {
          title: 'Informatique & Électronique',
          description: 'Ordinateurs, périphériques, équipements réseau, logiciels et solutions de sécurité',
          items: ['Matériel informatique', 'Équipements réseau', 'Logiciels professionnels'],
          image: 'https://images.unsplash.com/photo-1566647387313-9fda80664848'
        },
        {
          title: 'Solutions Numériques & SI',
          description: 'Conception de logiciels métiers, sites web, intégration réseaux et sécurité informatique',
          items: ['Logiciels sur mesure', 'Sites web & intranets', 'Sécurité & sauvegardes'],
          image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f'
        },
        {
          title: 'Électroménager Professionnel',
          description: 'Équipements électroménagers pour entreprises avec installation professionnelle',
          items: ['Réfrigérateurs industriels', 'Équipements de cuisine', 'Installation complète'],
          image: 'https://images.unsplash.com/photo-1570222094114-d054a817e56b'
        },
        {
          title: 'Maintenance & Réparations',
          description: 'Services de maintenance préventive et réparations rapides pour tous équipements',
          items: ['Maintenance préventive', 'Réparations d\'urgence', 'Inspections régulières'],
          image: 'https://images.unsplash.com/photo-1595856898575-9d187bd32fd6'
        },
        {
          title: 'Véhicules & Logistique',
          description: 'Vente et location de véhicules de fonction, solutions de mobilité complètes',
          items: ['Vente de véhicules', 'Location longue durée', 'Gestion de flotte'],
          image: 'https://images.unsplash.com/photo-1565043666747-69f6646db940'
        },
        {
          title: 'Énergie & Éclairage',
          description: 'Solutions énergétiques durables, panneaux solaires, groupes électrogènes',
          items: ['Panneaux solaires', 'Éclairage LED', 'Groupes électrogènes'],
          image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9'
        },
        {
          title: 'Infrastructures Électriques',
          description: 'Équipements électriques, transformateurs, câbles HT/MT, éclairage public',
          items: ['Poteaux & lampadaires', 'Transformateurs', 'Câbles HT/MT'],
          image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e'
        },
        {
          title: 'Services Aéronautiques',
          description: 'Acquisition, livraison et maintenance d\'avions civils pour missions spécialisées',
          items: ['Achat d\'avions', 'Formation équipages', 'Maintenance MRO'],
          image: 'https://images.unsplash.com/photo-1569154941061-e231b4725ef1'
        }
      ]
    },
    aircraft: {
      title: 'Capacités Aériennes',
      subtitle: 'Solutions aéronautiques complètes et modulables',
      intro: 'PRESTACO propose une architecture de flotte structurée pour couvrir un large spectre de missions aériennes, avec un soutien logistique intégré.',
      categories: {
        transport: {
          name: 'Transport Léger & Moyen',
          description: 'Avions de transport pour missions tactiques et logistiques',
          image: 'https://images.unsplash.com/photo-1763992524458-846ff46174bb'
        },
        training: {
          name: 'Entraînement & Appui',
          description: 'Avions d\'entraînement et d\'appui armé léger (COIN)',
          image: 'https://images.unsplash.com/photo-1676661096608-cc8535b9e2c0'
        },
        helicopters: {
          name: 'Hélicoptères',
          description: 'Hélicoptères légers et moyens pour missions variées',
          image: 'https://images.unsplash.com/photo-1603041385912-d622c2700422'
        },
        maritime: {
          name: 'Patrouille Maritime',
          description: 'Avions de surveillance et patrouille maritime',
          image: 'https://images.pexels.com/photos/914380/pexels-photo-914380.jpeg'
        },
        drones: {
          name: 'Drones MALE',
          description: 'Drones de surveillance longue endurance',
          image: 'https://images.unsplash.com/photo-1731579884331-95c1da04e988'
        },
        vip: {
          name: 'VIP & EVASAN',
          description: 'Aéronefs VIP et plateformes médicalisées',
          image: 'https://images.pexels.com/photos/76971/fighter-jet-fighter-aircraft-f-16-falcon-aircraft-76971.jpeg'
        }
      },
      services: {
        title: 'Services Intégrés',
        items: [
          'Fourniture d\'aéronefs complets',
          'Pièces détachées et soutien logistique',
          'Formation pilotes et techniciens',
          'Maintenance préventive',
          'Support technique 24/7',
          'Transfert de compétences'
        ]
      }
    },
    about: {
      title: 'À Propos de PRESTACO',
      subtitle: 'Notre Vision, Nos Valeurs',
      vision: {
        title: 'Notre Vision',
        content: 'Être le leader incontesté dans la fourniture de solutions d\'entreprise au Sénégal, partenaire privilégié des entreprises, offrant une gamme complète de produits et services de haute qualité.'
      },
      values: {
        title: 'Nos Valeurs',
        items: [
          { name: 'Intégrité', description: 'Transparence et honnêteté dans toutes nos actions' },
          { name: 'Innovation', description: 'Solutions modernes adaptées aux besoins évolutifs' },
          { name: 'Qualité', description: 'Excellence dans chaque produit et service fourni' },
          { name: 'Service Client', description: 'Satisfaction client au cœur de nos priorités' }
        ]
      },
      company: {
        title: 'Notre Entreprise',
        items: [
          { label: 'Forme juridique', value: 'SARL' },
          { label: 'Année de création', value: '2023' },
          { label: 'Siège social', value: 'Dakar, Sénégal' },
          { label: 'Secteur', value: 'Commerce / Distribution' }
        ]
      },
      expansion: {
        title: 'Objectifs d\'Expansion',
        content: 'Extension vers d\'autres pays africains : Maroc, Mauritanie, Guinée, Côte d\'Ivoire, Djibouti, Congo'
      }
    },
    contact: {
      title: 'Contactez-Nous',
      subtitle: 'Nous sommes à votre écoute',
      form: {
        name: 'Nom complet',
        email: 'Adresse email',
        phone: 'Téléphone',
        subject: 'Sujet',
        message: 'Message',
        send: 'Envoyer',
        sending: 'Envoi en cours...'
      },
      info: {
        address: '7 Nord Foire, Dakar, Sénégal',
        phone: '+221 77 266 93 93',
        email: 'info@prestacosn.com',
        hours: 'Lun - Ven: 8h00 - 18h00',
        coordinates: { lat: 14.749486382446511, lng: -17.463348816963173 }
      },
      success: 'Message envoyé avec succès !',
      error: 'Erreur lors de l\'envoi du message'
    },
    footer: {
      description: 'Solutions complètes pour entreprises et capacités aériennes au Sénégal',
      quickLinks: 'Liens Rapides',
      services: 'Services',
      contact: 'Contact',
      rights: 'Tous droits réservés'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      aircraft: 'Aircraft',
      projects: 'Projects',
      about: 'About',
      faq: 'FAQ',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'PRESTACO',
        subtitle: 'Your Trusted Partner',
        description: 'Complete business solutions and strategic air capabilities in Senegal',
        cta: 'Discover our services',
        ctaSecondary: 'Contact us'
      },
      intro: {
        title: 'Leader in Business Solutions',
        description: 'Since 2023, PRESTACO is a Senegalese company specializing in providing complete business solutions, from professional equipment to strategic air capabilities.'
      },
      stats: {
        founded: { value: '2023', label: 'Year founded' },
        revenue: { value: '200M+', label: 'FCFA revenue' },
        services: { value: '10+', label: 'Service categories' },
        clients: { value: '100%', label: 'Client satisfaction' }
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'A complete range of professional solutions',
      categories: [
        {
          title: 'Professional Equipment',
          description: 'Specialized work clothing, personalized accessories, safety equipment for all sectors',
          items: ['Work clothing', 'Safety equipment', 'Personalized accessories'],
          image: 'https://images.unsplash.com/photo-1662309376159-b95fb193d96b'
        },
        {
          title: 'IT & Electronics',
          description: 'Computers, peripherals, network equipment, software and security solutions',
          items: ['Computer hardware', 'Network equipment', 'Professional software'],
          image: 'https://images.unsplash.com/photo-1566647387313-9fda80664848'
        },
        {
          title: 'Digital Solutions & IS',
          description: 'Custom software design, websites, network integration and IT security',
          items: ['Custom software', 'Websites & intranets', 'Security & backups'],
          image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f'
        },
        {
          title: 'Professional Appliances',
          description: 'Professional appliances for businesses with complete installation',
          items: ['Industrial refrigerators', 'Kitchen equipment', 'Complete installation'],
          image: 'https://images.unsplash.com/photo-1570222094114-d054a817e56b'
        },
        {
          title: 'Maintenance & Repairs',
          description: 'Preventive maintenance and fast repairs for all equipment',
          items: ['Preventive maintenance', 'Emergency repairs', 'Regular inspections'],
          image: 'https://images.unsplash.com/photo-1595856898575-9d187bd32fd6'
        },
        {
          title: 'Vehicles & Logistics',
          description: 'Sale and rental of company vehicles, complete mobility solutions',
          items: ['Vehicle sales', 'Long-term rental', 'Fleet management'],
          image: 'https://images.unsplash.com/photo-1565043666747-69f6646db940'
        },
        {
          title: 'Energy & Lighting',
          description: 'Sustainable energy solutions, solar panels, generators',
          items: ['Solar panels', 'LED lighting', 'Generators'],
          image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9'
        },
        {
          title: 'Electrical Infrastructure',
          description: 'Electrical equipment, transformers, HV/MV cables, public lighting',
          items: ['Poles & street lights', 'Transformers', 'HV/MV cables'],
          image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e'
        },
        {
          title: 'Aeronautical Services',
          description: 'Acquisition, delivery and maintenance of civil aircraft for specialized missions',
          items: ['Aircraft purchase', 'Crew training', 'MRO maintenance'],
          image: 'https://images.unsplash.com/photo-1569154941061-e231b4725ef1'
        }
      ]
    },
    aircraft: {
      title: 'Air Capabilities',
      subtitle: 'Complete and modular aeronautical solutions',
      intro: 'PRESTACO offers a structured fleet architecture to cover a wide spectrum of air missions, with integrated logistics support.',
      categories: {
        transport: {
          name: 'Light & Medium Transport',
          description: 'Transport aircraft for tactical and logistics missions',
          image: 'https://images.unsplash.com/photo-1763992524458-846ff46174bb'
        },
        training: {
          name: 'Training & Support',
          description: 'Training aircraft and light armed support (COIN)',
          image: 'https://images.unsplash.com/photo-1676661096608-cc8535b9e2c0'
        },
        helicopters: {
          name: 'Helicopters',
          description: 'Light and medium helicopters for various missions',
          image: 'https://images.unsplash.com/photo-1603041385912-d622c2700422'
        },
        maritime: {
          name: 'Maritime Patrol',
          description: 'Maritime surveillance and patrol aircraft',
          image: 'https://images.pexels.com/photos/914380/pexels-photo-914380.jpeg'
        },
        drones: {
          name: 'MALE Drones',
          description: 'Long endurance surveillance drones',
          image: 'https://images.unsplash.com/photo-1731579884331-95c1da04e988'
        },
        vip: {
          name: 'VIP & MEDEVAC',
          description: 'VIP aircraft and medicalized platforms',
          image: 'https://images.pexels.com/photos/76971/fighter-jet-fighter-aircraft-f-16-falcon-aircraft-76971.jpeg'
        }
      },
      services: {
        title: 'Integrated Services',
        items: [
          'Complete aircraft supply',
          'Spare parts and logistics support',
          'Pilot and technician training',
          'Preventive maintenance',
          '24/7 technical support',
          'Skills transfer'
        ]
      }
    },
    about: {
      title: 'About PRESTACO',
      subtitle: 'Our Vision, Our Values',
      vision: {
        title: 'Our Vision',
        content: 'To be the undisputed leader in providing business solutions in Senegal, privileged partner of companies, offering a complete range of high-quality products and services.'
      },
      values: {
        title: 'Our Values',
        items: [
          { name: 'Integrity', description: 'Transparency and honesty in all our actions' },
          { name: 'Innovation', description: 'Modern solutions adapted to evolving needs' },
          { name: 'Quality', description: 'Excellence in every product and service provided' },
          { name: 'Customer Service', description: 'Customer satisfaction at the heart of our priorities' }
        ]
      },
      company: {
        title: 'Our Company',
        items: [
          { label: 'Legal form', value: 'SARL' },
          { label: 'Year founded', value: '2023' },
          { label: 'Headquarters', value: 'Dakar, Senegal' },
          { label: 'Sector', value: 'Commerce / Distribution' }
        ]
      },
      expansion: {
        title: 'Expansion Goals',
        content: 'Extension to other African countries: Morocco, Mauritania, Guinea, Ivory Coast, Djibouti, Congo'
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are listening',
      form: {
        name: 'Full name',
        email: 'Email address',
        phone: 'Phone',
        subject: 'Subject',
        message: 'Message',
        send: 'Send',
        sending: 'Sending...'
      },
      info: {
        address: '7 Nord Foire, Dakar, Senegal',
        phone: '+221 77 266 93 93',
        email: 'info@prestacosn.com',
        hours: 'Mon - Fri: 8:00 AM - 6:00 PM',
        coordinates: { lat: 14.749486382446511, lng: -17.463348816963173 }
      },
      success: 'Message sent successfully!',
      error: 'Error sending message'
    },
    footer: {
      description: 'Complete business solutions and air capabilities in Senegal',
      quickLinks: 'Quick Links',
      services: 'Services',
      contact: 'Contact',
      rights: 'All rights reserved'
    }
  }
};
